import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Email} from '../../../Models/Email';
import {LanguageModel} from '../../../../translation/translation.models';
import {BehaviorSubject} from 'rxjs';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LanguageService} from '../../../../translation/Services/language.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {EmailService} from '../../../Services/email.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {FormControl} from '@angular/forms';
import {environment} from '../../../../../environments/environment';
import * as Mustache from 'mustache';

@Component({
  selector: 'app-manage-email',
  templateUrl: './manage-email.component.html',
  styleUrls: ['./manage-email.component.scss'],
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in-out', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translate(0)'}),
        animate('400ms ease-in-out', style({opacity: 0}))
      ])
    ])
  ]
})
export class ManageEmailComponent implements OnInit {
  public autocompleteItems;
  public modules = {};
  public email: Email = new Email();
  public languages: LanguageModel[] = [];
  public actions = [];
  public isEdit = false;
  public tokens = [];
  public options: object = {
    charCounterCount: true,
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'outdent', 'indent', 'fontSize', '|', 'clearFormatting', 'insertTable', 'insertImage', 'html', 'source'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline', 'html'],
    toolbarSticky: true
  };
  public template = '';
  public iframeUrl: SafeResourceUrl;
  public iframeUrlCopy: SafeResourceUrl;
  @Input() public tabs = [];
  public copyTabs = [];
  public errorMessages = {
    'email': 'email is not valid',
  };
  public bcc: any[] = [];
  public copyCc: any[] = [];
  public listTokens: any[];
  public rawTokens: any[];
  public attachments = [];
  public bccInput: string = '';
  public copyCcInput: string = '';
  public activeId: number = 0;


  public constructor(private emailService: EmailService,
                     private languageService: LanguageService,
                     private translate: TranslateService,
                     private route: ActivatedRoute,
                     private sanitizer: DomSanitizer,
                     public helper: Helper,
                     private router: Router,
                     private auth: AuthenticationService) {
    this.route.params.subscribe((params: Params) => {
      this.modules = {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{'header': 1}, {'header': 2}],               // custom button values
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
          [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
          [{'direction': 'rtl'}],                         // text direction

          [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
          [{'header': [1, 2, 3, 4, 5, 6, false]}],

          [{'color': []}, {'background': []}],          // dropdown with defaults from theme
          [{'font': []}],
          [{'align': []}],

          ['clean'],                                         // remove formatting button

          ['link']                         // link and image, video
        ]
      };

      this.languageService.list().subscribe(languages => {
        this.languages = languages.languages;
        if (Helper.isDefined(params['id'])) {
          this.isEdit = true;
          this.emailService.getEmail(params['id']).subscribe(resp => {
            this.email = resp;
            this.emailService.getTemplate().subscribe(temp_resp => {
              this.template = temp_resp.content;
              this.emailService.getTokens(this.email.event).subscribe((token_resp) => {
                this.listTokens = token_resp.listTokens;
                this.rawTokens = token_resp.rawTokens;
                this.attachments = token_resp.attachments;
                this.email.language = (<LanguageModel>this.email.language).id;
                if (!this.email.copyBody) {
                  this.email.copyBody = this.email.body;
                  this.email.copyBodyMapping = Helper.deepCopyArray(this.email.bodyMapping);
                }
                this.bcc = (this.email.bcc || []).map(email => {
                  if (!email) {
                    return null;
                  }
                  return {display: email, value: email};
                }).filter(e => e);
                this.copyCc = (this.email.copyCc || []).map(email => {
                  if (!email) {
                    return null;
                  }
                  return {display: email, value: email};
                }).filter(e => e);
                this.parseTemplateContent();
                this.parseCopyTemplateContent();
                this.updateBody('email');
                this.updateBody('child');
              });
            });
          });
        }
      });
    });
    const filters = new URLSearchParams();
    filters.set('count', '1000');
  }


  public ngOnInit(): void {
  }

  public saveEmail($e) {
    const email = <Email>Object.assign({}, this.email);
    email.copyCc = [];
    for (const tag of this.copyCc) {
      if (!email.copyCc.includes(tag, 0)) {
        email.copyCc.push(tag.value);
      }
    }
    email.bcc = [];
    for (const tag of this.bcc) {
      if (!email.bcc.includes(tag, 0)) {
        email.bcc.push(tag.value);
      }
    }
    delete email.id;
    const attachments = [];
    email.attachments.forEach((item) => {
      if (item.id) {
        attachments.push(item.id);
      } else {
        attachments.push(item);
      }
    });
    email.attachments = attachments;
    this.emailService.update(this.email.id, email).subscribe(resp => {
      this.router.navigateByUrl('/back-office/emails/overview');
    });
  }

  public updateIframe(html) {
    const encodedHtml = btoa(unescape(encodeURIComponent(html)));
    const dataUrl = `data:text/html;base64,${encodedHtml}`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
  }

  public updateIframeCopy(html) {
    const encodedHtml = btoa(unescape(encodeURIComponent(html)));
    const dataUrl = `data:text/html;base64,${encodedHtml}`;
    this.iframeUrlCopy = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
  }

  parseTemplateContent() {
    this.tabs = [];
    for (const partial in this.email.bodyMapping) {
      if (! this.email.bodyMapping.hasOwnProperty(partial)) {
        continue;
      }
      this.tabs.push({title: partial, content: this.email.bodyMapping[partial]});
    }
  }


  parseCopyTemplateContent() {
    this.copyTabs = [];
    for (const partial in this.email.copyBodyMapping) {
      if (! this.email.copyBodyMapping.hasOwnProperty(partial)) {
        continue;
      }
      this.copyTabs.push({title: partial, content: this.email.copyBodyMapping[partial]});
    }
  }

  updateBody(kind) {
    try {
      const tokens = Object.assign(this.rawTokens, {email: this.email});
      if (kind === 'child') {
        const preview = Mustache.render(this.email.copyBody, tokens, this.email.copyBodyMapping);
        const htmlPreview = Mustache.render(this.template, tokens, {contentBody: preview});
        this.updateIframeCopy(htmlPreview);
      } else {
        const preview = Mustache.render(this.email.body, tokens, this.email.bodyMapping);
        const htmlPreview = Mustache.render(this.template, tokens, {contentBody: preview});
        this.updateIframe(htmlPreview);
      }
    } catch (e) {}
  }

  public clipboardUpdated() {
    this.helper.showNotify('',
      this.translate.instant('admin.emails.manage.copied_to_clipboard'),
      'success'
    );
  }

  public backToList() {
    this.router.navigateByUrl('/back-office/emails/overview');
  }

  public addEmail(event: any, type: 'bcc' | 'copyCc'): void {
    const input = type === 'bcc' ? this.bccInput : this.copyCcInput;
    const value = input.replace(',', '').trim();
    const emailRegex = new RegExp(environment.emailPattern);

    if (value && emailRegex.test(value)) {
      const newEmail = { display: value, value: value };
      
      if (type === 'bcc') {
        if (!this.bcc.some(e => e.value === value)) {
          this.bcc.push(newEmail);
        }
        this.bccInput = '';
      } else {
        if (!this.copyCc.some(e => e.value === value)) {
          this.copyCc.push(newEmail);
        }
        this.copyCcInput = '';
      }
    }
  }

  public removeEmail(email: any, type: 'bcc' | 'copyCc'): void {
    if (type === 'bcc') {
      this.bcc = this.bcc.filter(e => e.value !== email.value);
    } else {
      this.copyCc = this.copyCc.filter(e => e.value !== email.value);
    }
  }
}
